<template>
  <div>
    <div class="h-full flex items-center justify-center">
      <slot />
    </div>
  </div>
</template>
